import { useQuery } from 'react-query';

import { CACHE_KEYS, CACHE_TIMES } from '.';
import { api } from './swaggerApi';

export const useRootQuestionsList = (
  projectIdentifier: string,
  tapSurveyIds?: string[]
) => {
  return useQuery(
    [
      CACHE_KEYS.PROJECT_ROOT_QUESTIONS,
      projectIdentifier,
      [...(tapSurveyIds || [])],
    ],
    async () => {
      const { data } =
        await api.insightsPlatform.projectsRootQuestionsListDetail({
          identifier: projectIdentifier,
          tap_survey_ids: tapSurveyIds,
        });
      return data.data;
    },
    {
      enabled: !!projectIdentifier,
      keepPreviousData: true,
      staleTime: CACHE_TIMES.FIVE_MINUTES,
    }
  );
};

export const useLongitudinalQuestionResult = (
  tapQuestionIdentifier: string,
  tapSurveyIds: string[],
  filters?: Record<string, string[]>,
  group_rc_answers?: boolean
) => {
  return useQuery(
    [
      CACHE_KEYS.LONGITUDINAL_QUESTION_RESULTS,
      tapQuestionIdentifier,
      [...(tapSurveyIds || [])],
      group_rc_answers,
      { ...(filters || {}) },
    ],
    async () => {
      const { data } =
        await api.insightsPlatform.longitudinalTapQuestionsQuestionResultsDetail(
          {
            identifier: tapQuestionIdentifier,
            tap_survey_ids: tapSurveyIds,
            group_rc_answers: group_rc_answers,
            filters,
          }
        );
      return data.data;
    },
    {
      enabled: !!tapQuestionIdentifier && !!tapSurveyIds?.length,
      keepPreviousData: false,
      staleTime: CACHE_TIMES.TWO_MINUTES,
    }
  );
};

export const useRootTapAnswersList = (tapQuestionIdentifier: string) => {
  return useQuery(
    [CACHE_KEYS.QUESTION_ROOT_TAP_ANSWERS, tapQuestionIdentifier],
    async () => {
      const { data } =
        await api.insightsPlatform.longitudinalTapQuestionsRootTapAnswersListDetail(
          tapQuestionIdentifier
        );
      return data.data;
    },
    {
      enabled: !!tapQuestionIdentifier,
      keepPreviousData: true,
      staleTime: CACHE_TIMES.FIVE_MINUTES,
    }
  );
};
